import type { NextPage, GetServerSideProps } from 'next'
import Link from 'next/link'
import { useRouter } from 'next/router'
import SEO from '../../modules/seo'

export const getServerSideProps: GetServerSideProps = async (context) => {
  const searchQuery = context.query.query || ''
  return {
    redirect: {
      permanent: true,
      destination: "/board/notice",
    },
    props: {
      searchQuery
    }
  }
}


interface IProps {
  searchQuery: string;
}

const Component: NextPage<IProps> = ({ searchQuery }) => {
  const pageTitle = `게시판`

  return (
    <div className='flex flex-col justify-center'>
      <SEO title={pageTitle} />
      <div className='flex w-[1200px] items-center'>
        <div>
          <h2>게시판</h2>
        </div>
      </div>
    </div>
  )
}

export default Component
